<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AP2n6U/tc-custom/9781449484422.jpg?1737543917370" alt="This image is the cover for the book Sorry I Slept on Your Face"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sorry I Slept on Your Face
      </h1>
      <p class="bookDescription body article font2">
        <p>What does it mean when your cat bites your toes as hard as she can?  When she suffocates you with her body, is she just getting comfortable or is she trying to tell you she needs more space?  In <i>Sorry I Slept on Your Face</i>, cats, in all their superiority, break up with their owners through sorry/not sorry letters illustrated with cute, funny, sweet photographs.  This book will make you laugh and make you ponder your relationship with your own cat.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeremy Greenberg
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59bf610b